





























import { Component, Vue, Provide } from "vue-property-decorator";
import NewsItem from "@/components/NewsItem.vue";
import request from "@/api/index";
import { ColumnsConfig } from "@/common/BaseConfig";
import { IColumn, INewsItem } from "../api/types.d";
import { IDropdownItem } from "@/common/types";
import { List, PullRefresh } from "vant";
@Component({
  components: {
    NewsItem,
    VanList: List,
    VanPullRefresh: PullRefresh
  }
})
export default class ThingsAround extends Vue {
  columnList: IColumn[] = [];
  streetList: IDropdownItem[] = [];
  selectedStreet: string | number = "";
  private streetName: string = "";
  newsList: INewsItem[] = [];
  private loading: boolean = false;
  private finished: boolean = false;
  private lastItem?: INewsItem;
  private isLoading: boolean = false;

  get streetId() {
    return this.$store.state.streetId;
  }

  mounted() {
    this.getColumns();
  }

  /** 获取街道栏目数据 */
  getColumns() {
    request.getColumns(ColumnsConfig.街镇部门).then(result => {
      if (result.code === 0 && result.data.dataList) {
        this.columnList = result.data.dataList;
        this.setStreetList(result.data.dataList);
      }
    });
  }

  /** 设置街道列表 */
  setStreetList(list: IColumn[]) {
    list.forEach(item => {
      this.streetList.push({
        text: item.name,
        value: item.id
      });
    });
    if (this.streetId) {
      this.selectedStreet = this.streetId;
      this.streetName = this.streetList.find(
        item => item.value == this.selectedStreet
      )!.text;
      this.$store.commit("SET_STATE", {
        streetId: ""
      });
    } else {
      this.selectedStreet = this.streetList.find(
        item => item.text == "巴川街道"
      )!.value;
      this.streetName = "巴川街道";
    }
    this.getNewsList(this.selectedStreet + "");
  }

  /** 获取新闻列表 */
  getNewsList(columnId: string, isClear: boolean = false) {
    const lastId = this.lastItem ? this.lastItem!.id : undefined;
    const lastSortNo = this.lastItem ? this.lastItem!.sortNo : undefined;
    const lastOnlineTime = this.lastItem
      ? this.lastItem!.onlineTime
      : undefined;
    request
      .getNews(false, columnId, lastId, lastSortNo, lastOnlineTime)
      .then(result => {
        if (isClear) {
          this.newsList = [];
          this.finished = false;
        }
        if (!result.data.news || result.data.news.length === 0) {
          this.finished = true;
        } else {
          this.newsList = this.newsList.concat(result.data.news);
          this.lastItem = result.data.news.lastChild;
        }
        this.isLoading = false;
        this.loading = false;
      });
  }

  onLoad() {
    this.getNewsList(this.selectedStreet + "");
  }
  onRefresh() {
    this.lastItem = undefined;
    this.getNewsList(this.selectedStreet + "", true);
  }
  selectStreet() {
    this.$router.push(`/select-street?id=${ColumnsConfig.街镇部门}`);
  }
  messageClick() {
    this.$router.push(`/community-info`);
  }
}
